"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrderToGraphObject = exports.mapTableToGraphObject = void 0;
const lodash_isempty_1 = __importDefault(require("lodash.isempty"));
const mapTableToGraphObject = (table) => ({
    id: table.id,
    name: table.name || null,
    guestCount: table.guestCount || null,
    status: table.status || null,
    section: table.section
        ? {
            ...table.section,
            __typename: 'Section',
            type: 'id',
        }
        : null,
    __typename: 'OrderTable',
    type: 'id',
});
exports.mapTableToGraphObject = mapTableToGraphObject;
const mapOrderToGraphObject = (order) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return ({
        ...order,
        id: order.id,
        __typename: 'Order',
        roundingAmount: order.roundingAmount || 0,
        surchargeAmount: (order === null || order === void 0 ? void 0 : order.surchargeAmount) || 0,
        customer: order.customer
            ? {
                ...order.customer,
                type: 'id',
                id: order.customer.id,
                customerAccountDetails: (0, lodash_isempty_1.default)((_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.customerAccountDetails)
                    ? null
                    : (_b = order === null || order === void 0 ? void 0 : order.customer) === null || _b === void 0 ? void 0 : _b.customerAccountDetails,
                __typename: 'Customer',
            }
            : null,
        orderItems: (order.orderItems || []).map(item => {
            var _a, _b, _c;
            return ({
                ...item,
                id: item.id,
                notes: item.notes || null,
                surchargeAmount: item.surchargeAmount || 0,
                __typename: 'OrderItem',
                product: item.product
                    ? {
                        type: 'id',
                        id: item.product.id,
                        __typename: 'Product',
                    }
                    : null,
                variant: item.variant
                    ? {
                        type: 'id',
                        id: (_a = item.variant) === null || _a === void 0 ? void 0 : _a.id,
                        __typename: 'Variant',
                    }
                    : null,
                discounts: item.discounts
                    ? item.discounts.map(x => ({
                        ...x,
                        discount: { ...x, type: 'id', __typename: 'Discount' },
                        __typename: 'Discount',
                    }))
                    : [],
                modifiers: item.modifiers
                    ? item.modifiers.map(modifier => ({
                        ...modifier,
                        __typename: 'OrderItemModifier',
                        type: 'id',
                        taxes: item.taxes
                            ? item.taxes.map(x => ({ id: x.id, __typename: 'Tax', type: 'id' }))
                            : [],
                    }))
                    : [],
                adjustments: item.adjustments
                    ? item.adjustments.map(adjustment => ({
                        ...adjustment,
                        name: adjustment.name ? adjustment.name : null,
                        type: 'id',
                        __typename: 'Adjustment',
                    }))
                    : [],
                taxes: item.taxes
                    ? item.taxes.map(x => ({ id: x.id, __typename: 'Tax', type: 'id' }))
                    : [],
                reason: item.reason || null,
                itemFired: item.itemFired || null,
                seatNumber: item.seatNumber || null,
                createdAt: item.createdAt || null,
                saved: item.saved || null,
                course: ((_b = item === null || item === void 0 ? void 0 : item.course) === null || _b === void 0 ? void 0 : _b.id)
                    ? {
                        id: (_c = item === null || item === void 0 ? void 0 : item.course) === null || _c === void 0 ? void 0 : _c.id,
                        __typename: 'Course',
                    }
                    : null,
                paymentStatus: (item === null || item === void 0 ? void 0 : item.paymentStatus) || null,
            });
        }),
        orderType: order.orderType
            ? {
                id: order.orderType.id,
                __typename: 'OrderType',
                type: 'id',
            }
            : null,
        table: order.table && order.table.id ? (0, exports.mapTableToGraphObject)(order.table) : null,
        tables: ((_c = order.tables) === null || _c === void 0 ? void 0 : _c.length) ? order.tables.map(exports.mapTableToGraphObject) : null,
        venue: order.venue
            ? { id: order.venue.id, type: 'id', __typename: 'Venue' }
            : null,
        store: order.store
            ? { id: order.store.id, type: 'id', __typename: 'Store' }
            : null,
        organization: order.organization
            ? { id: order.organization.id, type: 'id', __typename: 'Organization' }
            : null,
        payments: order.payments
            ? order.payments.map(x => {
                var _a, _b;
                return ({
                    ...x,
                    id: x.id,
                    roundOffDifference: x.roundOffDifference || null,
                    paymentRequestId: x.paymentRequestId || null,
                    paymentTransactionRef: x.paymentTransactionRef || null,
                    paymentCompletedAt: x.paymentCompletedAt || null,
                    paymentReceipt: x.paymentReceipt || null,
                    paymentSurcharge: x.paymentSurcharge || null,
                    cardType: x.cardType || null,
                    paymentType: ((_a = x.paymentType) === null || _a === void 0 ? void 0 : _a.id)
                        ? {
                            __typename: 'PaymentType',
                            id: x.paymentType.id,
                            type: 'id',
                        }
                        : null,
                    customer: ((_b = x.customer) === null || _b === void 0 ? void 0 : _b.id)
                        ? {
                            __typename: 'Customer',
                            id: x.customer.id,
                            type: 'id',
                        }
                        : null,
                    __typename: 'OrderPayment',
                });
            })
            : [],
        orderNote: (_d = order.orderNote) !== null && _d !== void 0 ? _d : '',
        amountDue: (_e = order.amountDue) !== null && _e !== void 0 ? _e : null,
        createdBy: order.createdBy
            ? { id: order.createdBy.id, __typename: 'User', type: 'id' }
            : null,
        updatedBy: order.updatedBy
            ? { id: order.updatedBy.id, __typename: 'User', type: 'id' }
            : null,
        createdByDevice: order.createdByDevice
            ? { id: order.createdByDevice.id, __typename: 'Device', type: 'id' }
            : null,
        updatedByDevice: order.updatedByDevice
            ? { id: order.updatedByDevice.id, __typename: 'Device', type: 'id' }
            : null,
        taxes: order.taxes
            ? order.taxes.map(x => ({
                ...x,
                tax: { ...x.tax, type: 'id', __typename: 'Tax' },
                __typename: 'OrderTax',
            }))
            : [],
        discounts: order.discounts
            ? order.discounts.map(x => ({
                ...x,
                discount: { ...x, type: 'id', __typename: 'Discount' },
                __typename: 'Discount',
            }))
            : [],
        adjustments: order.adjustments
            ? order.adjustments.map(adjustment => ({
                ...adjustment,
                createdAt: adjustment.createdAt ? adjustment.createdAt : null,
                maximumAmount: adjustment.maximumAmount
                    ? adjustment.maximumAmount
                    : null,
                name: adjustment.name ? adjustment.name : null,
                quantity: adjustment.quantity ? adjustment.quantity : null,
                saved: adjustment.saved ? adjustment.saved : null,
                type: 'id',
                __typename: 'Adjustment',
            }))
            : [],
        reason: order.reason || null,
        refundOf: order.refundOf || null,
        isEdited: order.isEdited || false,
        lastSyncedEventId: order.lastSyncedEventId,
        salesChannel: order.salesChannel
            ? { id: order.salesChannel.id, type: 'id', __typename: 'SalesChannel' }
            : null,
        integrationInfo: order.integrationInfo
            ? {
                id: order.integrationInfo.id,
                app: order.integrationInfo.app,
                channelOrderId: (_f = order === null || order === void 0 ? void 0 : order.integrationInfo) === null || _f === void 0 ? void 0 : _f.channelOrderId,
                channelOrderDisplayId: (_g = order === null || order === void 0 ? void 0 : order.integrationInfo) === null || _g === void 0 ? void 0 : _g.channelOrderDisplayId,
                type: 'id',
                __typename: 'IntegrationInfo',
            }
            : null,
        requiredAt: order.requiredAt || null,
        lastCheck: (_h = order.lastCheck) !== null && _h !== void 0 ? _h : order.updatedAt,
        lastOrderedAt: order.lastOrderedAt || null,
        shippingAddress: order.shippingAddress || null,
        courier: order.courier || null,
        deliveryFee: order.deliveryFee || null,
        ordersMerged: order.ordersMerged || null,
        serviceCharge: order.serviceCharge || null,
        tip: order.tip || null,
        rewardDiscountAmount: order.rewardDiscountAmount || 0,
        loyaltySnapshot: order.loyaltySnapshot
            ? {
                ...order.loyaltySnapshot,
                availableRewards: (_k = (_j = order.loyaltySnapshot) === null || _j === void 0 ? void 0 : _j.availableRewards) === null || _k === void 0 ? void 0 : _k.map(reward => ({ ...reward, __typename: 'RewardByDiscountEntireSale' })),
                __typename: 'LoyaltySnapshot',
            }
            : null,
        dueAt: order.dueAt || null,
    });
};
exports.mapOrderToGraphObject = mapOrderToGraphObject;
//# sourceMappingURL=mapOrderToGraphQL.js.map